var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toolbar-tooltip"},[_c(_vm.icon,{tag:"component",staticClass:"toolbar-tooltip-SVG"}),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.instructions)+" ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b16da06","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Toolbars/CreateObjects/InstructionsTooltip.vue
// module id = null
// module chunks = 